import { Horizon } from '@stellar/stellar-sdk';
import BigNumber from 'bignumber.js';

type ReserveAccount = Pick<
    Horizon.AccountResponse,
    'balances' | 'subentry_count' | 'num_sponsoring' | 'num_sponsored'
>;

export const getAvailableNativeBalance = (account: ReserveAccount): number => {
    const native = account.balances.find(balance => balance.asset_type === 'native');
    if (!native) return 0;
    const reserve =
        (2 + account.subentry_count + account.num_sponsoring - account.num_sponsored) * 0.5;
    return Math.max(
        new BigNumber(native.balance).minus(reserve).minus(native.selling_liabilities).toNumber(),
        0,
    );
};

export const getAvailableSwapNativeBalance = (account: ReserveAccount, additionalReserve = 0) =>
    Math.max(
        new BigNumber(getAvailableNativeBalance(account))
            .minus(2) // Existing swap fee buffer.
            .minus(additionalReserve)
            .toNumber(),
        0,
    );
